enum ClockType {
  HOURS = 'hours',

  MINUTES = 'minutes',

  SECONDS = 'seconds',
}

// TODO: fix naming, this should be consistent with the DateTimePickerView file
export type ClockTypeType = 'hours' | 'minutes' | 'seconds';

export default ClockType;



// WEBPACK FOOTER //
// ../../src/constants/ClockType.ts